import FaqListPage from "@/views/customerService/FaqListPage.vue";
import InquiryCreatePage from "@/views/customerService/InquiryCreatePage.vue";
import PrivacyPolicyPage from "@/views/customerService/PrivacyPolicyPage.vue";
import TermsOfUsePage from "@/views/customerService/TermsOfUsePage.vue";
import NoticeListPage from "@/views/customerService/NoticeListPage.vue";
import NoticeDtlPage from "@/views/customerService/NoticeDtlPage.vue";

const customerServiceRoutes = [
  {
    path: "/customer-service",
    children: [
      {
        path: "faq-list",
        name: "FaqListPage",
        component: FaqListPage
      },
      {
        path: "inquiry-create",
        name: "InquiryCreatePage",
        component: InquiryCreatePage
      },
      {
        path: "privacy-policy",
        name: "PrivacyPolicyPage",
        component: PrivacyPolicyPage
      },
      {
        path: "terms-of-use",
        name: "TermsOfUsePage",
        component: TermsOfUsePage
      },
      {
        path: "notice-dtl/:noticeSeq",
        name: "NoticeDtlPage",
        components: {
          default: NoticeDtlPage,
        },
        props: {
          default: true,
        },
      },
      {
        path: "notice",
        name: "NoticeListPage",
        components: {
          default: NoticeListPage,
        },
        props: {
          default: true,
        },
      },
    ],
  },
]

export default customerServiceRoutes;